import React, { useState } from "react";
import {
  FaWhatsapp,
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaArrowLeft,
  FaArrowRight,
  FaTiktok,
} from "react-icons/fa";

const bloquesPadres = [
  {
    titulo: "Crecimiento espiritual",
    contenido: [
      {
        subtitulo: "Presentación clara del Evangelio",
        texto:
          "Cada equipo del Campamento de Entrenamiento del Señor asiste a las reuniones nocturnas para recibir la conferencia, anuncios, adoración y un mensaje de la Palabra de Dios, impartido por oradores invitados con mucha experiencia y nuestro propio personal. El mensaje de salvación, a través de la sangre derramada de Jesucristo en la cruz, se presenta claramente y se brinda la oportunidad de responder y dar el primer paso como nuevo creyente en Cristo. Se anima a todos los adolescentes a dejar de lado cualquier obstáculo en su vida espiritual o en su ministerio de verano. Nuestro personal misionero capacitado a tiempo completo y los líderes voluntarios están disponibles después para ofrecer aliento, consejo, lecturas bíblicas y oración.",
      },
      {
        subtitulo: "Devocionales personales diarios",
        texto:
          "Una parte del programa diario se mantiene invariable durante el entrenamiento, los viajes, el proyecto y el reporte. Cada mañana, durante todo este programa, todas las actividades se detienen durante 30 minutos para la devoción personal: un tiempo para leer la Palabra de Dios y orar. Esperamos que esto ayude a establecer un hábito que perdure toda la vida.",
      },
      {
        subtitulo: "Versículos bíblicos para memorizar",
        texto:
          "Los miembros del equipo aprenden un versículo bíblico cada día y lo recitan de memoria a un líder. Aprenden 40 versículos útiles para jóvenes y para la evangelización. Cada fin de semana, el equipo disfruta de un concurso de versículos para repasar lo aprendido. Quienes tengan dificultades para memorizar pueden recibir ayuda personalizada para aprender todos los versículos.",
      },
    ],
  },

  {
    titulo: "Cómo establecer mejores hábitos",
    contenido: [
      {
        subtitulo: "Desconectarse",
        texto:
          "El mundo actual está repleto de distracciones, muchas de ellas incluso positivas. Sin embargo, durante las vacaciones, cada joven se compromete a dejar de lado los dispositivos electrónicos, los videojuegos, los teléfonos móviles, los deportes, las películas, las citas y otras distracciones. Esto ayuda a fortalecer las relaciones con todo el equipo, así como con los jóvenes de la ciudad o país anfitrión.",
      },
      {
        subtitulo: "Disciplina",
        texto:
          "Todo el programa de entrenamiento misionero incluye normas necesarias para la seguridad, la unidad del equipo y un testimonio cristiano positivo durante el viaje y en el extranjero. Los líderes reciben capacitación para enseñar y hacer cumplir la disciplina adecuada. A lo largo del programa, los miembros del equipo aprenden autocontrol, respeto por la autoridad y el valor del orden y la disciplina.",
      },
      {
        subtitulo: "Trabajo en equipo",
        texto:
          "El entrenamiento en el Campamento de Entrenamiento del Señor es exigente y requiere trabajo en equipo. Cuando alguien tropieza o se desanima, los demás lo apoyan y animan. Aprender a trabajar con otros es una valiosa habilidad para la vida, tanto en el trabajo como en el ministerio.",
      },
      {
        subtitulo: "Diligencia, trabajo duro y potencial",
        texto:
          "Durante el programa, a cada equipo se le asigna un proyecto importante que, en muchos casos, requiere nuevas habilidades. Tanto el trabajo como las tareas de evangelización exigirán esfuerzo y perseverancia para completar cada una. El carácter y la confianza se fortalecen a medida que los miembros del equipo aprenden la verdad de Filipenses 4:13: «Todo lo puedo en Cristo que me fortalece».",
      },
      {
        subtitulo: "Gratitud",
        texto:
          "Damos muchas cosas por sentado. Cada día tenemos un techo sobre nuestras cabezas, agua potable, padres que nos proveen de comida y ropa y que lavan nuestra ropa. Disfrutamos de la música y otras comodidades materiales. La mayor parte del mundo no vive como nosotros. La mayoría de los miembros del equipo regresan a casa mucho más agradecidos por las pequeñas cosas que, en realidad, no son tan pequeñas.",
      },
    ],
  },

  {
    titulo: "Nuevos talentos y experiencias",

    contenido: [
      {
        subtitulo: "Descubriendo nuevos talentos",
        texto:
          "Muchos miembros del equipo no se dan cuenta de que sus talentos e intereses personales son muy necesarios para la obra del Señor. Les presentamos diversos aspectos del trabajo misionero y el ministerio, conscientes de que podrían descubrir, por primera vez, cómo Dios podría guiarlos en su futuro ministerio.",
      },

      {
        subtitulo: "Capacitación práctica y experiencia ministerial",
        texto:
          "A continuación, se presenta una lista parcial de la capacitación práctica y la experiencia ministerial que se han ofrecido a lo largo de los años durante el programa de viajes misioneros de verano. No todas estas áreas se ofrecen cada año.",
      },
    ],

    areas: [
      "Ministerio de Música - Voz",
      "Ministerio de Música - Instrumental",
      "Drama",
      "Ministerio de títeres y niños",
      "Enseñanza de algún idioma",
      "Colocación básica de ladrillos para construcción",
      "Carpintería básica",
      "Atado básico de fierro",
      "Mezcla básica de hormigón",
      "Construcción de cercos",
      "Instalación eléctrica básica",
      "Madurez (Serie bíblica de cuatro partes)",
      "Servicio (Serie bíblica de cuatro partes)",
      "Presentando el plan de salvación",
      "Misiones en diferentes contextos",
      "Perforación de pozos de agua",
      "Melodramas y coreografías para evangelismo",
      "Evangelización deportiva",
      "Misiones médicas",
      "Ministerios para huérfanos",
      "Entrenamiento para adolescentes a nivel nacional",
    ],
  },
  {
    titulo: "Mayor visión y pasión por llegar a las naciones",
    contenido: [
      {
        subtitulo: "Mayor comprensión de nuestro mundo",
        texto:
          "Los adolescentes aprenderán sobre otras costumbres y culturas. Además, podrán admirar la belleza de la creación de Dios al visitar muchos paisajes de diferentes ciudades.",
      },
      {
        subtitulo:
          "Mayor conciencia de las necesidades de los misioneros y de los no alcanzados",
        texto:
          "Juan 3:16 dice que «de tal manera amó Dios al mundo». Es probable que tu adolescente sienta una mayor preocupación por las oportunidades de servir y orar por los perdidos en todo el mundo.",
      },
      {
        texto:
          "Nuestros equipos han construido pistas de aterrizaje en la selva para pilotos misioneros, puentes que salvan vidas en la sabana africana, un hospital fronterizo en Papúa Nueva Guinea y cientos de iglesias, escuelas y orfanatos, a menudo desde cero hasta un techo cerrado, antes de partir.",
      },
      {
        texto:
          "Nuestros equipos colaboran con jóvenes e iglesias locales para realizar evangelización al aire libre y testimonios personales. Estos esfuerzos han resultado en miles de decisiones por Cristo y, en algunos casos, nuevas iglesias nacieron gracias al éxito de estas iniciativas.",
      },
      {
        texto:
          "Al finalizar el verano, los adolescentes se dan cuenta de que Dios puede usarlos ahora para hacer cosas que nunca antes habían imaginado posibles, a la vez que se hacen más conscientes de las necesidades y posibilidades de participar y apoyar futuras misiones.",
      },
    ],
  },
];

export default function Padres() {
  const [indiceActual, setIndiceActual] = useState(0);

  const bloqueAnterior = () => {
    setIndiceActual((indice) =>
      indice === 0 ? bloquesPadres.length - 1 : indice - 1,
    );
  };

  const bloqueSiguiente = () => {
    setIndiceActual((indice) =>
      indice === bloquesPadres.length - 1 ? 0 : indice + 1,
    );
  };

  return (
    <main className="pagina-padres">
      {/* =========================================
          1. HERO PADRES
      ========================================= */}

      <section
        className="hero-padres"
        style={{
          minHeight: "95vh",
          backgroundImage:
            "linear-gradient(rgba(8, 1, 1, 0.55), rgba(11, 2, 12, 0.75)), url('https://thumbs-us-east-1.myalbum.io/photo/1k0/3a1535b1-2530-4427-ac83-7834c99cbf77.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginTop: "50px",
        }}
      >
        <div className="hero-overlay-padres">
          <div className="container text-center">
            <h1 className="titulo-padres display-2 fw-bold titulo-secciones">
              Para padres de familia
            </h1>
            <p className="texto-hero-padres">
              Agradecemos su apoyo y comprendemos la importancia de su
              participación en cada etapa del programa de nuestro campamento de
              entrenamiento misionero, para que su hijo(a) participe en un viaje
              misionero en estas vacaciones con Teen Missions Perú. Queremos que
              conozca nuestro programa de entrenamiento de forma
              sencilla.¡Veamos ahora algunas razones importantes para enviar a
              su hijo(a) a un viaje misionero estas vacaciones!
            </p>
          </div>
        </div>
      </section>

      {/* =========================================
          2. EQUIPO DE ORACIÓN
      ========================================= */}

      <section className="padres-oracion py-5">
        <div className="container text-center">
          <h2 className="titulo-seccion-padres">
            Únete al Equipo de Oración del Campamento de Entrenamiento
          </h2>

          <p className="texto-seccion-padres">
            Ninguna actividad ministerial en este programa sería posible sin
            nuestros dedicados equipos de oración. Este año, hemos tomado la
            iniciativa de movilizar un equipo de oración para que acompañe y
            fortalezca a nuestros equipos.
          </p>

          {/* WHATSAPP */}

          <a
            href="https://chat.whatsapp.com/HlhkLLdbKMi4uQ8zlTYHoM"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-whatsapp-padres"
          >
            <FaWhatsapp />
            ÚNETE AL GRUPO DE ORACIÓN
          </a>

          {/* PDF */}

          <p className="texto-guia-oracion">
            Puedes descargar y seguir nuestra guía de oración para este evento{" "}
            <a
              href="/pdf/guia_oracion.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              aquí
            </a>
            . (Descargar en pdf)
          </p>
        </div>
      </section>

      {/* =========================================
          3. EQUIPO DE MEDIOS
      ========================================= */}

      <section className="padres-medios py-5">
        <div className="container text-center">
          <h2 className="titulo-seccion-padres">
            Equipo de medios digitales y redes Sociales
          </h2>

          <p className="texto-seccion-padres">
            Nuestro equipo de medios trabaja arduamente durante todo el
            campamento de entrenamiento para que puedas conocer la historia de
            cada misionero en formación. Cada etapa, el equipo se esforzará por
            subir un álbum de fotos y un video con fragmentos del día.
          </p>

          <p className="texto-seccion-padres">
            Las fotos se encuentran en nuestras redes sociales y en esta página.
          </p>

          {/* REDES SOCIALES */}

          <div className="redes-padres">
            <a
              href="https://www.facebook.com/TMIP1/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link text-white"
            >
              <FaFacebook />
            </a>

            <a
              href="https://www.instagram.com/teenmissionsperu/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link text-white"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.youtube.com/@teenmissionsperu"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link text-white"
            >
              <FaYoutube />
            </a>

            <a
              href="https://www.tiktok.com/@teenmissionsperu"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link text-white"
            >
              <FaTiktok />
            </a>

            <a
              href="https://wa.me/51987706440"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link text-white"
            >
              <FaWhatsapp />
            </a>
          </div>

          {/* BOTÓN INFORMES */}

          <button type="button" className="btn-informes-padres">
            INFORMES DE VIAJE 2027
          </button>
        </div>
      </section>

      {/* =========================================
          4. BLOQUES INFORMATIVOS
      ========================================= */}

      <section className="padres-bloques py-5">
        <div className="container">
          <h2 className="titulo-seccion-padres text-center mb-5">
            Un impacto transformador en tus vacaciones.
          </h2>

          <div className="padres-toggle-contenedor">
            {/* Flechas para móvil */}
            <div className="padres-toggle-flechas-mobile">
              <button
                type="button"
                className="padres-toggle-flecha"
                onClick={bloqueAnterior}
                aria-label="Información anterior"
              >
                <FaArrowLeft />
              </button>

              <button
                type="button"
                className="padres-toggle-flecha"
                onClick={bloqueSiguiente}
                aria-label="Siguiente información"
              >
                <FaArrowRight />
              </button>
            </div>

            {/* Flecha izquierda PC */}
            <button
              type="button"
              className="padres-toggle-flecha padres-flecha-pc"
              onClick={bloqueAnterior}
              aria-label="Información anterior"
            >
              <FaArrowLeft />
            </button>

            {/* Caja */}
            <div className="padres-toggle-caja">
              <h3>{bloquesPadres[indiceActual].titulo}</h3>

              {bloquesPadres[indiceActual].contenido && (
                <div className="padres-toggle-contenido">
                  {bloquesPadres[indiceActual].contenido.map((item, index) => (
                    <div key={index} className="padres-toggle-item">
                      <h4>{item.subtitulo}</h4>
                      <p>{item.texto}</p>
                    </div>
                  ))}
                </div>
              )}

              {bloquesPadres[indiceActual].areas && (
                <div className="areas-capacitacion">
                  <h4 className="areas-titulo">
                    Áreas de capacitación y experiencia
                  </h4>

                  <div className="areas-grid">
                    {bloquesPadres[indiceActual].areas.map((area, index) => (
                      <div key={index} className="area-card">
                        {area}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Flecha derecha PC */}
            <button
              type="button"
              className="padres-toggle-flecha padres-flecha-pc"
              onClick={bloqueSiguiente}
              aria-label="Siguiente información"
            >
              <FaArrowRight />
            </button>
          </div>

          {/* Indicadores */}
          <div className="padres-toggle-indicadores">
            {bloquesPadres.map((_, index) => (
              <button
                key={index}
                type="button"
                className={
                  index === indiceActual
                    ? "padres-indicador activo"
                    : "padres-indicador"
                }
                onClick={() => setIndiceActual(index)}
                aria-label={`Mostrar información ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
